import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import PopOver from 'chameleon/ui-stack/ui/base/popover';

import './styles.scss';

/**
 * Renders an icon with a description when clicked.
 * */
const IconWithDescription = (props) => {
  const {
    className,
    buttonClassName,
    width,
    trigger,
    onTriggerClick,
    children,
    popoverAriaLabel,
    tooltipAriaLabel,
    ariaLive,
    defaultOpen,
    withPortal,
  } = props;

  return (
    <PopOver
      defaultOpen={defaultOpen}
      position="bottom"
      className={cn('IconWithDescriptionContainer', {
        [className]: !!className,
      })}
      buttonClassName={buttonClassName}
      onToggle={onTriggerClick}
      size={width}
      withPortal={withPortal}
      accessibility={{
        'aria-label': popoverAriaLabel,
        'aria-describedby': 'icon-with-description-tooltip',
      }}
      trigger={trigger}
    >
      <span
        id="icon-with-description-tooltip"
        data-test-id="icon-with-description-tooltip"
        aria-live={ariaLive || 'assertive'}
        aria-label={tooltipAriaLabel}
      >
        {children}
      </span>
    </PopOver>
  );
};

IconWithDescription.displayName = 'IconWithDescription';

IconWithDescription.props = {
  // CSS class for customization.
  className: PropTypes.string,
  // The width of the popover.
  width: PropTypes.string,
  // The label of the popover. This element triggers to popover to open/close.
  trigger: PropTypes.element.isRequired,
  // The React children property to render inside the popover.
  children: PropTypes.element.isRequired,
  // The aria label for the popover. Used for accessibility.
  popoverAriaLabel: PropTypes.string,
  // The aria label for the popover content. Used for accessibility.
  tooltipAriaLabel: PropTypes.string,
  // Callback function for onPopOverClick.
  onTriggerClick: PropTypes.func,
  defaultOpen: PropTypes.bool,
};

IconWithDescription.defaultProps = {
  className: null,
  width: 'auto',
  popoverAriaLabel: null,
  tooltipAriaLabel: null,
  onTriggerClick: null,
  defaultOpen: false,
};

export default IconWithDescription;
